import { chatActions } from "../../chat";
import { GetMessagesResponse } from "../../chat/types";
import { getOperatorName } from "../providers";
import { TypingNotificationContent } from "../types";
import { DICTIONARY } from "../../chat/dictionary";
import type { AppDispatch, AppStore } from "../../../store";

const { setOperatorName } = chatActions;

const handleOperatorEnterChat = (
  dispatch: AppDispatch,
  msg: GetMessagesResponse["data"]
) => {
  if (msg?.messages && msg.messages[0]) {
    const name = getOperatorName(msg.messages[0]);

    if (name) {
      dispatch(setOperatorName(name));
    }
  }
};

export const setOperatorNameHandler = (
  { dispatch }: AppStore,
  msg: GetMessagesResponse["data"] | TypingNotificationContent
) => {
  if (msg) {
    if ("userId" in msg && msg.userId === 1) {
      dispatch(setOperatorName(DICTIONARY.MESSAGE_BOT));
    } else {
      handleOperatorEnterChat(dispatch, msg);
    }
  }
};
